import { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { RepairStatus } from '../enums/repair-status';
import { useAppSelector } from '../store/hooks';
import { cancelRepair, repairSelector, updateNotes } from '../store/repair-slice';
import NoteModal from './note-modal';
import PinModal from './pin-modal';

const RepairUpdateHeader = () => {
  const dispatch = useDispatch();
  const organization = useAppSelector((state) => state.auth.organization!);
  const { notes, repair } = useSelector(repairSelector);
  const [showNoteModal, setShowNoteModal] = useState<boolean>(false);
  const [showPinModal, setShowPinModal] = useState<boolean>(false);

  const onCloseNoteModal = () => {
    setShowNoteModal(false);
  };

  const onSaveNoteModal = (notes: string | null) => {
    dispatch(updateNotes({ notes }));
    setShowNoteModal(false);
  };

  const onDeleteNoteModal = () => {
    dispatch(updateNotes({ notes: null }));
    setShowNoteModal(false);
  };

  const onCancelRepair = (pin: string | null) => {
    dispatch(cancelRepair({ organizationId: organization.id, pin }));
  };

  return (
    <div className="repair-update-header">
      <div className="d-flex align-items-center">
        <div className="col">
          {(repair?.repairStatus === RepairStatus.Budget ||
            repair?.repairStatus === RepairStatus.Finished ||
            repair?.repairStatus === RepairStatus.InProcess ||
            repair?.repairStatus === RepairStatus.Opened) && (
            <button
              className="cancel-repair"
              onClick={() => {
                if (organization.requireTransactionPin) {
                  setShowPinModal(true);
                  return;
                }
                onCancelRepair(null);
              }}
            >
              Cancelar
            </button>
          )}
        </div>
        <div className="col text-center">
          <h1 className="title mb-0">{repair!.internalId}</h1>
        </div>
        <div className="col">
          {notes != null && notes !== '' ? (
            <span onClick={() => setShowNoteModal(true)} className="has-notes">
              1 Nota
            </span>
          ) : (
            <span onClick={() => setShowNoteModal(true)} className="notes">
              + Notas
            </span>
          )}
        </div>
      </div>
      <NoteModal editable={true} show={showNoteModal} notes={notes} closeModal={onCloseNoteModal} saveNotes={onSaveNoteModal} deleteNotes={onDeleteNoteModal} />
      <PinModal
        show={showPinModal}
        onCloseModal={(pin) => {
          setShowPinModal(false);
          if (pin === null || pin.length !== 4) {
            return;
          }
          onCancelRepair(pin);
        }}
      />
    </div>
  );
};

export default RepairUpdateHeader;
